import { ContainerModule } from 'inversify';
import {
  MessageManager,
  MessageStrategyTypes,
  IMessageStrategy,
  PlainMessageStrategy,
  createPlainMessageStrategy,
} from '@framework/message';
import messageCodes from '@framework/message/messages';
import messageMapping from '@framework/message/Mapper/messageMapping';
import I18nMessageStrategy from './I18nMessageStrategy';

export const messageManagerModule: ContainerModule = new ContainerModule(({ bind }) => {
  bind(PlainMessageStrategy).toDynamicValue(() => {
    return createPlainMessageStrategy(messageCodes, messageMapping);
  });
  bind<IMessageStrategy>(MessageStrategyTypes).to(I18nMessageStrategy).inSingletonScope();
  bind(MessageManager).toSelf().inSingletonScope();
});
